(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-featured-product"] && !Shopify.designMode) return;
  try {
    
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.accordion__content');
  
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
  
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
  
      shrink() {
        this.isClosing = true;
  
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
  
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }
  
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }
  
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
        if (stickyData === 'true') {
          sidebar.updateSticky();
        }
      }
    }
  
    document.querySelectorAll('details.accordion__details').forEach((el) => {
      new Accordion(el);
    });
  
    function adjustBoxWidth() {
      const boxes = document.querySelectorAll('.block-message p');
      boxes.forEach((box) => {
        boxes.forEach((box1) => {
          box1.classList.remove('full-width');
        });
        const lineHeight = parseFloat(window.getComputedStyle(box).lineHeight);
        const boxHeight = box.scrollHeight;
        if (boxHeight > lineHeight * 1.5) {
          boxes.forEach((box1) => {
            box1.classList.add('full-width');
          });
        }
      });
    }
  
    window.addEventListener('load', adjustBoxWidth);
    window.addEventListener('resize', () => {
      clearTimeout(window.adjustTimeout);
      window.adjustTimeout = setTimeout(adjustBoxWidth, 100);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-shop"] && !Shopify.designMode) return;
  try {
    
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.accordion__content');
  
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
  
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
  
      shrink() {
        this.isClosing = true;
  
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
  
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }
  
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }
  
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
        if (stickyData === 'true') {
          sidebar.updateSticky();
        }
      }
    }
  
    document.querySelectorAll('details.accordion__details').forEach((el) => {
      new Accordion(el);
    });
  
    function adjustBoxWidth() {
      const boxes = document.querySelectorAll('.block-message p');
      boxes.forEach((box) => {
        boxes.forEach((box1) => {
          box1.classList.remove('full-width');
        });
        const lineHeight = parseFloat(window.getComputedStyle(box).lineHeight);
        const boxHeight = box.scrollHeight;
        if (boxHeight > lineHeight * 1.5) {
          boxes.forEach((box1) => {
            box1.classList.add('full-width');
          });
        }
      });
    }
  
    window.addEventListener('load', adjustBoxWidth);
    window.addEventListener('resize', () => {
      clearTimeout(window.adjustTimeout);
      window.adjustTimeout = setTimeout(adjustBoxWidth, 100);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.searchModal = document.querySelector('details-modal.header__search');
        if (this.searchModal) {
          this.searchModal.addEventListener('modalOpened', () => {
            this.preventReveal = true;
          });

          this.searchModal.addEventListener('modalClosed', () => {
            this.preventReveal = false;
          });
        }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.preventReveal) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

      document.addEventListener('DOMContentLoaded', () => {
        if (window.innerWidth > 990) {
          let desktopSearch = document.querySelector('.inline_header_search.header-inline-pred');
          let headerDiv = document.querySelector('#shopify-section-header');
      
          if (desktopSearch && headerDiv) {
            let headerHeight = headerDiv.offsetHeight;
            const parentTop = headerDiv.getBoundingClientRect().top;
            const targetTop = desktopSearch.getBoundingClientRect().top;
            const relativeTop = targetTop - parentTop;
            let heightPred = headerHeight - relativeTop;
      
            let predictiveSearch = document.querySelector('.predictive-search--header');
            if (predictiveSearch) {
              predictiveSearch.style.top = heightPred + 'px';
            }
          }
        }
            function adjustBannerHeight() {
              const bannerBoxes = document.querySelectorAll('.banner__box');

              bannerBoxes.forEach((bannerBox) => {
                  const parentDiv = bannerBox.closest('.banner');

                  if (parentDiv) {
                      const bannerBoxHeight = bannerBox.offsetHeight;
                      const parentDivHeight = parentDiv.offsetHeight

                      if (bannerBoxHeight > parentDivHeight) {
                          parentDiv.style.height = `${bannerBoxHeight}px`;
                      } else {
                          parentDiv.style.height = '';
                      }
                  }
              });
          }

          window.addEventListener('load', adjustBannerHeight);
          window.addEventListener('resize', adjustBannerHeight);
      });
  
  const menuItems = document.querySelectorAll('.mega-menu');
  let tries = 0;
  const maxTries = 10;
  const interval = setInterval(() => {
    tries++;
    if (typeof SV !== "undefined" && typeof SV.HoverIntent === "function") {
      new SV.HoverIntent(menuItems, {
        onEnter: function(targetItem) {
          targetItem.setAttribute("open", true);
          document.querySelector("#mega-menu-overlay").style.display = "block";
        },
        onExit: function(targetItem) {
          targetItem.removeAttribute("open");
          document.querySelector("#mega-menu-overlay").style.display = "none";
        },
        exitDelay: 400
      });
      clearInterval(interval);
    } else if (tries >= maxTries) {
      clearInterval(interval);
      console.warn("SV.HoverIntent was not defined after 10 tries.");
    }
  }, 100);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hex--header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      if (this.announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  function adjustBoxWidth() {
    const boxes = document.querySelectorAll('.block-message p');
    boxes.forEach((box) => {
      boxes.forEach((box1) => {
        box1.classList.remove('full-width');
      });
      const lineHeight = parseFloat(window.getComputedStyle(box).lineHeight);
      const boxHeight = box.scrollHeight;
      if (boxHeight > lineHeight * 1.5) {
        boxes.forEach((box1) => {
          box1.classList.add('full-width');
        });
      }
    });
  }

  window.addEventListener('load', adjustBoxWidth);
  window.addEventListener('resize', () => {
    clearTimeout(window.adjustTimeout);
    window.adjustTimeout = setTimeout(adjustBoxWidth, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-orders"] && !Shopify.designMode) return;
  try {
    
  function initializeColorSwatchSliders() {
    document.querySelectorAll('.product-new-featured .new-product-swatch').forEach((sliderElement) => {
      new Swiper(sliderElement, {
        slidesPerView: 4.3,
        slidesPerGroup: 1,
        spaceBetween: 7,
        autoHeight: true,
        observer: true,
        observeParents: true,
        parallax: true,
        breakpoints: {
          1200: {
            slidesPerView: 5.5,
            spaceBetween: 7,
          },
          600: {
            slidesPerView: 4.5,
            spaceBetween: 7,
          },
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
        },
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initializeColorSwatchSliders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-featured-collection"] && !Shopify.designMode) return;
  try {
    
  function initializeColorSwatchSliders() {
    document.querySelectorAll(".product-new-featured .new-product-swatch").forEach(sliderElement => {
      if (!sliderElement.classList.contains('swiper-initialized')) {
        const swiper = new Swiper(sliderElement, {
          slidesPerView: 4.3,
          slidesPerGroup: 1,
          spaceBetween: 7,
          autoHeight: true,
          observer: true,
          observeParents: true,
          parallax: true,
          preloadImages: true,
          updateOnImagesReady: true,
          breakpoints: {
            1200: {
              slidesPerView: 5.5,
              spaceBetween: 7
            },
            600: {
              slidesPerView: 4.5,
              spaceBetween: 7
            }
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
            sensitivity: 1
          }
        });

        // ✅ Force update after short delay to fix hidden-section issue
        setTimeout(() => {
          swiper.update();
        }, 800);
      }
    });
  }

  // ✅ Run immediately after DOM load
  document.addEventListener("DOMContentLoaded", function() {
    initializeColorSwatchSliders();

    // ✅ Force recheck after everything is loaded
    window.addEventListener('load', function() {
      initializeColorSwatchSliders();

      // ✅ Also trigger an update once more after 1s (for lazy-loaded content)
      setTimeout(() => {
        document.querySelectorAll('.swiper-initialized').forEach(swiperEl => {
          swiperEl.swiper?.update();
        });
      }, 1000);
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach(container => {
      new Swiper(container.querySelector('.swiper'), {
        slidesPerView: parseFloat(container.dataset.perviewDesktop) || 4,
        spaceBetween: parseInt(container.dataset.spaceDesktop) || 20,
        breakpoints: {
          320: {
            slidesPerView: parseFloat(container.dataset.perviewMobile) || 2.2,
            spaceBetween: parseInt(container.dataset.spaceMobile) || 15,
          },
          768: {
            slidesPerView: parseFloat(container.dataset.perviewTablet) || 2.5,
            spaceBetween: parseInt(container.dataset.spaceDesktop) || 20,
          },
        },
        autoHeight: container.dataset.autoheight === 'true',
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-grid"] && !Shopify.designMode) return;
  try {
    
  function initializeColorSwatchSliders() {
    document.querySelectorAll('.new-product-grid__card .new-product-swatch').forEach((sliderElement) => {
      new Swiper(sliderElement, {
        slidesPerView: 4.3,
        slidesPerGroup: 1,
        spaceBetween: 7,
        autoHeight: true,
        observer: true,
        observeParents: true,
        parallax: true,
        breakpoints: {
          1200: { slidesPerView: 5.5, spaceBetween: 7 },
          600: { slidesPerView: 4.5, spaceBetween: 7 },
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          sensitivity: 1,
        },
      });
    });
  }
  initializeColorSwatchSliders();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery-video"]) return;
  try {
    
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.accordion__content');
  
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
  
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
  
      shrink() {
        this.isClosing = true;
  
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
  
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }
  
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }
  
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
        if (stickyData === 'true') {
          sidebar.updateSticky();
        }
      }
    }
  
    document.querySelectorAll('details.accordion__details').forEach((el) => {
      new Accordion(el);
    });
  
    function adjustBoxWidth() {
      const boxes = document.querySelectorAll('.block-message p');
      boxes.forEach((box) => {
        boxes.forEach((box1) => {
          box1.classList.remove('full-width');
        });
        const lineHeight = parseFloat(window.getComputedStyle(box).lineHeight);
        const boxHeight = box.scrollHeight;
        if (boxHeight > lineHeight * 1.5) {
          boxes.forEach((box1) => {
            box1.classList.add('full-width');
          });
        }
      });
    }
  
    window.addEventListener('load', adjustBoxWidth);
    window.addEventListener('resize', () => {
      clearTimeout(window.adjustTimeout);
      window.adjustTimeout = setTimeout(adjustBoxWidth, 100);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim()) {
            this.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }
          
          if (html.querySelector('.swiper-slide')) {
            this.initializeSwiper();
            this.initializeColorSwatchSliders();
          }
        })
        .catch(console.error);
    };

    new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' }).observe(this);
  }

  initializeSwiper() {
    new Swiper('.product-recommendations-slider', {
      slidesPerView: 1.2,
      spaceBetween: 15,
      slidesPerGroup: 1,
      autoHeight: false,
      observer: true,
      observeParents: true,
      parallax: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: (swiper, current, total) => `${current} / ${total}`,
      },
      breakpoints: {
        991: { slidesPerView: 3.5, spaceBetween: 20 },
        600: { slidesPerView: 2.5, spaceBetween: 20 }
      }
    });
  }

  initializeColorSwatchSliders() {
    document.querySelectorAll(".new-product-swatch").forEach(sliderElement => {
      new Swiper(sliderElement, {
        slidesPerView: 4.3,
        slidesPerGroup: 1,
        spaceBetween: 7,
        autoHeight: true,
        observer: true,
        observeParents: true,
        parallax: true,
        breakpoints: {
          1200: { slidesPerView: 5.5, spaceBetween: 7 },
          600:{ slidesPerView: 4.5, spaceBetween: 7 }
        },
        keyboard: {
    enabled: true,
    onlyInViewport: true, 
  },
  mousewheel: {
    enabled: true,
    forceToAxis: true,  
    sensitivity: 1,    
  }
      });
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-page-proprogram"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      open ? this.el.closest('.page-width').classList.add('accordion-open') : this.el.closest('.page-width').classList.remove('accordion-open');
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();
})();
